import { useEffect, useState } from "react";
import { fetchWalletHistory } from "../../services/profileService";

export default function WalletHistory() {
  const [walletData, setWalletData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState({
    startDate: "All",
    endDate: "All",
  });

  /* ===== CURRENCY FORMATTER ===== */
  const formatCurrency = (value) => {
    const number = Number(value) || 0;

    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  };

  const loadWalletHistory = async () => {
    setLoading(true);

    try {
      const data = await fetchWalletHistory(
        filter.startDate,
        filter.endDate
      );

      if (data.status) {
        setWalletData(data.data || []);
        setTotal(Number(data.total) || 0);
      }
    } catch (err) {
      console.error("Wallet load error:", err);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadWalletHistory();
  }, [filter]);

  return (
    <div className="profile-card">
      <h3>Wallet History</h3>

      {/* ===== TOTAL EARNING ===== */}
      <div className="wallet-total">
        <h2>{formatCurrency(total)}</h2>
        <span>Total Earnings</span>
      </div>

      {/* ===== DATE FILTER ===== */}
      <div className="wallet-filter">
        <input
          type="date"
          onChange={(e) =>
            setFilter((prev) => ({
              ...prev,
              startDate: e.target.value || "All",
            }))
          }
        />

        <input
          type="date"
          onChange={(e) =>
            setFilter((prev) => ({
              ...prev,
              endDate: e.target.value || "All",
            }))
          }
        />
      </div>

      {/* ===== HISTORY LIST ===== */}
      {loading ? (
        <p>Loading...</p>
      ) : walletData.length === 0 ? (
        <p>No wallet history found.</p>
      ) : (
        <div className="wallet-list">
          {walletData.map((item, index) => (
            <div key={index} className="wallet-item">
              <div>
                <strong>{item.reason || "Transaction"}</strong>
                <p>
                  {new Date(item.createdAt).toLocaleDateString()}
                </p>
              </div>

              <div className="wallet-amount">
                <span
                  className={
                    item.amount > 0
                      ? "amount-positive"
                      : "amount-negative"
                  }
                >
                  {item.amount > 0 ? "+" : "-"}
                  {formatCurrency(Math.abs(item.amount))}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
